<template>
  <ContextMenuWrapper>
    <ZtButtonContext data-testid="viewer-share-who-is-viewing" :label="whoIsViewing?.title || ''" :icon="whoIsViewing?.icon" @open="onMenuOpen" />

    <template #menu>
      <template v-for="item in whoCanView" :key="item.name">
        <MenuLink :icon="item.icon" :disabled="item?.disabled" :title="item.title" @click="runAction(item)">
          {{ item.title }}
        </MenuLink>
      </template>
      <MenuUpselling v-if="free" class="mt-3" text="Safely share with your team." href="/plans?utm_campaign=upgrade&utm_medium=button&utm_source=viewer" />
    </template>
  </ContextMenuWrapper>

  <ContextMenuWrapper v-if="!!whoHasAccess">
    <ZtButtonContext data-testid="viewer-share-who-has-access" :label="whoIsAccessing?.title || ''" :icon="whoIsAccessing?.icon" />

    <template #menu>
      <template v-for="item in whoHasAccess" :key="item.name">
        <MenuSeparator v-if="item?.isSeparator" />
        <MenuModal v-else-if="item?.action?.type === 'modal'" :icon="item.icon" :type="item.type" :component="item.action.params.component">
          {{ item.title }}
        </MenuModal>
        <MenuLink v-else :icon="item.icon" :disabled="item?.disabled" :title="item.title" @click="runAction(item)">
          {{ item.title }}
        </MenuLink>
      </template>
      <MenuUpselling
        v-if="free"
        class="mt-3"
        text="Set a password or an email collector."
        href="/plans?utm_campaign=upgrade&utm_medium=button&utm_source=viewer"
      />
    </template>
  </ContextMenuWrapper>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ContextMenuWrapper, MenuLink, MenuModal, MenuUpselling, MenuSeparator, ZtButtonContext } from '@/storybook';

import { useSecurityToolbar } from '@/modules/viewer/composables/useSecurityToolbar';

import { useOrganizationStore } from '@/store/useOrganizationStore';
import { TrackClickEvents, useTrack } from '@/composables/useTrack';

const organizationStore = useOrganizationStore();
const { free } = storeToRefs(organizationStore);

const { whoCanView, whoIsViewing, whoHasAccess, whoIsAccessing } = useSecurityToolbar();
const { trackClick } = useTrack();

const onMenuOpen = () => trackClick(TrackClickEvents.SHARE_SETTINGS);

const runAction = (item?: any) => {
  const { action } = item;

  if (item.trackClick) {
    trackClick(item.trackClick);
  }

  if (typeof action === 'function') {
    action();
  }
};
</script>
